import { render, staticRenderFns } from "./MenuTopNavi.vue?vue&type=template&id=c3899fc0&scoped=true&"
import script from "./MenuTopNavi.vue?vue&type=script&lang=ts&"
export * from "./MenuTopNavi.vue?vue&type=script&lang=ts&"
import style0 from "./MenuTopNavi.vue?vue&type=style&index=0&id=c3899fc0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3899fc0",
  null
  
)

export default component.exports